import { v4 } from "uuid"
import { ICustomerFormValue } from "../../../../../pages/TableMap/components/customerForm/ICustomerFormValue"
import { IOrder } from "../../../../cart/domain/models/IOrder"
import { ConsumptionItemAdditionalRequest, ConsumptionItemObservationRequest, ConsumptionItemRequest, SyncOrderRequest, SyncOrderTransactions } from "../../../../prePaidTickets/domain/dtos/SyncPrePaidTickets"
import { OrderStatus } from "../../../../prePaidTickets/domain/OrderStatus"
import { ProductType } from "../../../../catalog/domain/models/ProductType"

const OrderToSyncOrderRequest = (values: {
    registerSessionId: string,
    localId: string,
    operatorId?: string,
    totalAmount: number,
    order: IOrder,
    discount?: number,
    notes?: string,
    orderStatus: OrderStatus,
    customer?: ICustomerFormValue
    transactions: SyncOrderTransactions[]
    codePanel?: string
}): SyncOrderRequest => {


    const details = values.order.orderItems.map(item => {


        const additionals: ConsumptionItemAdditionalRequest[] = []
        const observation: ConsumptionItemObservationRequest[] = []

        item.orderComposition?.flatMap(item => item.compositionItems).forEach(compositionItem => {
            if (compositionItem.productId) {
                const additionalItem: ConsumptionItemAdditionalRequest = {
                    productId: compositionItem.productId,
                    selectedQuantity: compositionItem.quantity,
                    unitValue: compositionItem.price,
                    discountValue: compositionItem.price,
                    complementGroupId: compositionItem.compositionId
                }
                additionals.push(additionalItem)
            }
        })

        item.orderComposition?.forEach(composition => {
            composition.compositionItems.map(compositionItem => {
                if (!compositionItem.productId) {
                    const _composition: ConsumptionItemObservationRequest = {
                        id: compositionItem.id,
                        question: composition.description,
                        answer: compositionItem.description,
                    }
                observation.push(_composition)
                }
            })
        })

        const totalAdditionals = additionals.reduce((acc, curr) => acc + curr.unitValue, 0) //TODO: Verificar se é necessário somar os additionals

        const detail: ConsumptionItemRequest = {
            ticketsIds: item.ticketIds ?? [...Array.from({ length: item.productType === ProductType.Kilo ? 1 : item.quantity }).map(() => v4())],
            productId: item.productId,
            productName: item.name,
            //unitValue: item.price + totalAdditionals,
            unitValue: item.totalPrice, //
            // discountValue: item.discount,
            quantity: item.quantity,
            annotation: item.notes,
            additionals: additionals,
            observations: observation,
            optionsOldFormat: "[]", //todo: Verificar 
        }
        return detail
    })

    const [day, month, year]: number[] = values.customer?.birthDate ? values.customer.birthDate.split('/').map(Number) : [];
    const birthDate = new Date(year, month - 1, day);

    const response: SyncOrderRequest = {
        localId: values.localId,
        sessionRegistryPOSId: values.registerSessionId,
        operatorId: values.operatorId,
        totalAmount: values.totalAmount, //nullable
        discount: values.discount, //nullable
        details: details,
        orderId: values.order.id, //nullable
        orderStatus: values.orderStatus, //nullable
        orderDate: new Date(), //nullable
        transactions: values.transactions,
        noteOrder: values.notes, //nullable}
        customerEstablishment: {
            name: values.customer?.name ?? "",
            telephone: values.customer?.phoneNumber,
            birthDate: birthDate,
            document: values.customer?.document,
            child: "",
            email: values.customer?.email,
        },
        codePanel: values.codePanel,
    }
    return response
}
export default OrderToSyncOrderRequest